module.exports = new __parcel__URL__("yo.cc18edbb.mp3").toString();